import React from "react";
import styled from "styled-components";

import { withRouter } from "react-router-dom";

import Card from "../common/Card";

const Container = styled.header`
  display: flex;
  align-items: center;
  max-width: 1180px;
  height: 60px;
  margin-left: auto;
  margin-right: auto;
`;

function Header() {
  return (
    <Card>
      <Container />
    </Card>
  );
}

export default withRouter(Header);
